export default function _of(x) {
  return [x];
}


//////////////////
// WEBPACK FOOTER
// ./~/ramda/es/internal/_of.js
// module id = 1722
// module chunks = 1